// src/components/common/intercom/IntercomDataUpdater.js
import { useEffect, useRef } from 'react';
import { updateAllIntercomData } from './intercomUtils';

/**
 * Componente que actualiza periódicamente los datos en Intercom
 * @param {Object} props Propiedades del componente
 * @param {number} props.updateInterval Intervalo de actualización en milisegundos
 * @returns {null} No renderiza nada en el DOM
 */
const IntercomDataUpdater = ({ updateInterval = 30 * 60 * 1000 }) => {
  const intervalRef = useRef(null);
  
  useEffect(() => {
    // Actualizar datos inmediatamente al montar
    const updateData = async () => {
      try {
        await updateAllIntercomData();
        console.log('Datos de Intercom actualizados correctamente');
      } catch (error) {
        console.error('Error al actualizar datos en Intercom:', error);
      }
    };
    
    // Primera actualización
    updateData();
    
    // Configurar actualización periódica
    intervalRef.current = setInterval(updateData, updateInterval);
    
    // Limpiar al desmontar
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [updateInterval]);
  
  // Este componente no renderiza nada
  return null;
};

export default IntercomDataUpdater;